import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IMember } from 'src/app/interfaces/member';
import { OrganisationMemberDataSource } from './organisation-member-data-source';
import { ApiService } from 'src/app/services/api.service';
import { CommonFunctionService } from 'src/app/services/common-function.service';

@Injectable()
export class OrganisationMemberApiService {
  constructor(
    private Api: ApiService,
    protected commonFunctionService: CommonFunctionService
  ) {}

  public getDataSource(organisationId: number) {
    return new OrganisationMemberDataSource(organisationId, this);
  }

  public list(
    role: string,
    organisationId: number,
    filter?: {}
  ): Promise<IMember[]> {
    let endpoint = `organisation-admin/organisation-id/${organisationId}/members`;
    endpoint = this.commonFunctionService.addFilterToEndpointWithoutPagination(
      endpoint,
      filter
    );
    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.get(endpoint, url).then(
      (Members: IMember[]) => Members,
      async (error) => {
        await this.Api.handleError(error);
        throw error;
      }
    );
  }
}
